export const WP_API_BASE = '/wp-json/pch/v2/njdiet/'
